document.addEventListener('DOMContentLoaded', function () {
  const btns = document.querySelectorAll('.country-selector-button');
  const closeBtn = document.getElementById('close-country-drawer');

  btns.forEach(btn => btn.addEventListener('click', function () {
    if (window.__toggleCountryDrawer) window.__toggleCountryDrawer(true);
  }));

  if (closeBtn) closeBtn.addEventListener('click', function () {
    if (window.__toggleCountryDrawer) window.__toggleCountryDrawer(false);
  });
});
